/*
 * CircuitForm Messages
 *
 * This contains all the text for the CircuitForm component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  name: {
    id: 'app.components.CircuitForm.name',
    defaultMessage: 'Name',
  },
  language: {
    id: 'app.components.CircuitForm.language',
    defaultMessage: 'Language',
  },
  circuitOverseerName: {
    id: 'app.components.CircuitForm.circuitOverseerName',
    defaultMessage: 'Name of circuit overseer',
  },
  circuitOverseerEmail: {
    id: 'app.components.CircuitForm.circuitOverseerEmail',
    defaultMessage: 'Email of circuit overseer',
  },
});
